import { render, staticRenderFns } from "./memberPointRecordList.vue?vue&type=template&id=4af5e802"
import script from "./memberPointRecordList.vue?vue&type=script&lang=js"
export * from "./memberPointRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports